// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"424":"defb628e","517":"0c69f516"}[chunkId] + ".chunk.js";
};